'use client';

import { c as _c } from "react/compiler-runtime";
import { PermissionError } from '@/app/(frontend)/[locale]/[design]/(payload-pages)/[[...slugs]]/permission-error';
import { PreviewError } from '@/app/(frontend)/[locale]/[design]/(payload-pages)/[[...slugs]]/preview-error';
import { useSearchParams } from 'next/navigation';
import type React from 'react';
export const CustomErrorBoundaryFallback: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const searchParameters = useSearchParams();
  const error = searchParameters.get("error") ?? "";
  if (error === "permission") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PermissionError />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const requestedAsPreview = searchParameters.get("preview") === "true";
  if (requestedAsPreview) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PreviewError />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <>{children}</>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};